import React from 'react';
import { Link, NavLink, useLocation, useNavigate, useParams } from 'react-router-dom';
import { PAGE_CREATE_MODIFIER, PAGE_MENUS, PAGE_MODIFIERS } from '../../constants/UriConstants';
import AddItemButtons from '../AddItemButtons';
import PageHeader from '../PageHeader';
import { useRestaurantContext } from '../../contexts/RestaurantContext';

const MenuTopBar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { restaurantID } = useParams<{ restaurantID: string }>();
  const { menus, currentRestaurant } = useRestaurantContext();
  const isMenuItemsView = pathname.includes(PAGE_MENUS) || pathname === '/';
  const isModifiersView = pathname.includes(PAGE_MODIFIERS);

  const addressLine = [currentRestaurant?.address?.address1, currentRestaurant?.address?.address2]
    .filter(Boolean)
    .join(' ');

  const cityStateZip = [
    currentRestaurant?.address?.city,
    currentRestaurant?.address?.governingDistrict,
    currentRestaurant?.address?.postalCode
  ]
    .filter(Boolean)
    .join(', ');

  const fullAddressOneLine = [addressLine, cityStateZip].filter(Boolean).join(', ').toUpperCase();

  const handleMenuItemClick = () => {
    navigate(`/${restaurantID}/${PAGE_MENUS}`);
  };

  const handleMenuItemKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (event.code === 'Enter' || event.code === 'Space') {
      navigate(`/${restaurantID}/${PAGE_MENUS}`);
    }
  };

  const hasMenuSections = () => {
    let hasValues = false;

    menus.forEach((menu) => {
      if (menu?.menuSections?.length > 0) {
        hasValues = true;
      }
    });

    return hasValues;
  };

  return (
    <>
      <PageHeader title="MENUS">
        {hasMenuSections() && isMenuItemsView ? <AddItemButtons /> : null}
        {isModifiersView ? (
          <Link to={`/${PAGE_CREATE_MODIFIER}`} className="page-header__action-button add-modifier-button">
            ADD MODIFIER
          </Link>
        ) : null}
      </PageHeader>

      <div
        style={{
          backgroundColor: '#4a4f5c',
          padding: '16px 50px',
          display: 'flex',
          alignItems: 'center',
          gap: '16px'
        }}
      >
        <span
          style={{
            color: 'white',
            fontSize: '14px',
            fontWeight: 600,
            letterSpacing: '1px'
          }}
        >
          {currentRestaurant?.name?.toUpperCase()}
        </span>

        <span
          style={{
            color: '#b0b3ba',
            fontSize: '12px',
            letterSpacing: '0.5px'
          }}
        >
          {fullAddressOneLine}
        </span>
      </div>

      <nav className="menu-top-bar-tabs" aria-label="Menu views">
        <span
          role="button"
          onClick={handleMenuItemClick}
          onKeyPress={handleMenuItemKeyPress}
          tabIndex={0}
          className={`menu-top-selection ${isMenuItemsView ? 'active' : ''}`}
        >
          MENU ITEMS
        </span>

        <NavLink
          to={`/${restaurantID}/${PAGE_MODIFIERS}`}
          className={({ isActive }) => (isActive ? 'menu-top-selection active' : 'menu-top-selection')}
        >
          MODIFIERS
        </NavLink>
      </nav>
    </>
  );
};

export default MenuTopBar;
